import React from "react";
import { useLocation, Link } from "react-router-dom";
import "./Footer.css";

import lapstayLogo from "../../Images/lapstaylogo.webp";
import instagramIcon from "../../Images/insta.webp";
import twitterIcon from "../../Images/twitter.webp";
import facebookIcon from "../../Images/facebook.webp";
import footerArrow from "../../Images/footerarro.webp";
import ornamentIcon from "../../Images/footerflower.webp";
import airbnb from '../../Images/airbnblogo.jpg';
function Footer() {
  const year = new Date().getFullYear();
  const location = useLocation();

  const validRoutes = [
    "/",
    "/hotels",
    "/hotel",
    "/contact",
    "/about",
    "/sitemap",
    "/dashboard",
    "/terms",
    "/privacy",
    "/careers",
    "/testimonials",
  ];

  const isValidRoute = validRoutes.some(
    (route) =>
      location.pathname === route ||
      location.pathname.startsWith("/hotel/") ||
      location.pathname.startsWith("/hotels/")
  );

  if (!isValidRoute) return null;

  return (
    <footer
      className="lapstay-footer"
      itemScope
      itemType="https://schema.org/Organization"
    >
      <div className="lapstay-footer__inner">
        {/* Brand Column */}
        <div className="lapstay-footer__brand">
          <Link
            to="/"
            className="lapstay-footer__logo"
            aria-label="LapStay home"
            onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          >
            <img
              src={lapstayLogo}
              alt="LapStay - Stay, Ease, Bliss"
              className="lapstay-footer__logo-img"
              itemProp="logo"
            />
          </Link>

          <div className="lapstay-footer__rule" aria-hidden="true">
            <img
              src={ornamentIcon}
              alt=""
              className="lapstay-footer__ornament-icon"
            />
          </div>

          <p className="lapstay-footer__desc" itemProp="description">
            Curated luxury stays designed for comfort, privacy, and
            unforgettable experiences.
          </p>

          <div className="lapstay-footer__socials">
            <a
              href="https://www.instagram.com/lapstayluxe?igsh=Yzl1YXA3aTA3bm1w"
              className="lapstay-footer__social-link"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LapStay on Instagram"
              itemProp="sameAs"
            >
              <img
                src={instagramIcon}
                alt=""
                className="lapstay-footer__social-icon-img"
              />
            </a>
            <a
              href="https://x.com/_Lapstayluxe"
              className="lapstay-footer__social-link"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LapStay on Twitter / X"
              itemProp="sameAs"
            >
              <img
                src={twitterIcon}
                alt=""
                className="lapstay-footer__social-icon-img"
              />
            </a>
            <a
              href="https://www.facebook.com/share/19ErLYB8bY/"
              className="lapstay-footer__social-link"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LapStay on Facebook"
              itemProp="sameAs"
            >
              <img
                src={facebookIcon}
                alt=""
                className="lapstay-footer__social-icon-img"
              />
            </a>
            <a
              href="https://www.airbnb.com/users/show/lapstay"
              className="lapstay-footer__social-link"
              target="_blank"
              rel="noopener noreferrer"
              aria-label="LapStay on Airbnb"
              itemProp="sameAs"
            >
          <img
                src={airbnb}
                alt=""
                className="lapstay-footer__social-icon-img"
              />
            </a>
          </div>
        </div>

        {/* Quick Links Column */}
        <nav className="lapstay-footer__col" aria-label="Quick links">
          <h3>QUICK LINKS</h3>
          <span
            className="lapstay-footer__heading-underline"
            aria-hidden="true"
          />
          <ul>
            <li>
              <a
                href="/about"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.assign("/about");
                }}
              >
                <span>About</span>
                <img
                  src={footerArrow}
                  className="lapstay-footer__arrow"
                  alt=""
                  aria-hidden="true"
                />
              </a>
            </li>
            <li>
              <a
                href="/hotels"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.assign("/hotels");
                }}
              >
                <span>Properties</span>
                <img
                  src={footerArrow}
                  className="lapstay-footer__arrow"
                  alt=""
                  aria-hidden="true"
                />
              </a>
            </li>
            <li>
              <a
                href="/#experience-section"
                onClick={(e) => {
                  e.preventDefault();
                  if (window.location.pathname === "/") {
                    document
                      .getElementById("experience-section")
                      ?.scrollIntoView({ behavior: "smooth" });
                  } else {
                    window.location.assign("/#experience-section");
                  }
                }}
              >
                <span>Experiences</span>
                <img
                  src={footerArrow}
                  className="lapstay-footer__arrow"
                  alt=""
                  aria-hidden="true"
                />
              </a>
            </li>
            <li>
              <a
                href="/careers"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.assign("/careers");
                }}
              >
                <span>Careers</span>
              </a>
            </li>
          </ul>
        </nav>

        {/* Divider 1 */}
        <span className="lapstay-footer__divider" aria-hidden="true" />

        {/* Legal Column */}
        <nav className="lapstay-footer__col" aria-label="Legal">
          <h3>LEGAL</h3>
          <span
            className="lapstay-footer__heading-underline"
            aria-hidden="true"
          />
          <ul>
            <li>
              <a
                href="/terms"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.assign("/terms");
                }}
              >
                <span>Terms &amp; Condition</span>
                <img
                  src={footerArrow}
                  className="lapstay-footer__arrow"
                  alt=""
                  aria-hidden="true"
                />
              </a>
            </li>
            <li>
              <a
                href="/privacy"
                onClick={(e) => {
                  e.preventDefault();
                  window.location.assign("/privacy");
                }}
              >
                <span>Privacy &amp; Policy</span>
                <img
                  src={footerArrow}
                  className="lapstay-footer__arrow"
                  alt=""
                  aria-hidden="true"
                />
              </a>
            </li>
          </ul>
        </nav>

        {/* Divider 2 */}
        <span className="lapstay-footer__divider" aria-hidden="true" />

        {/* Contact Column */}
        <div className="lapstay-footer__col lapstay-footer__col--contact">
          <h3>CONTACT</h3>
          <span
            className="lapstay-footer__heading-underline"
            aria-hidden="true"
          />
          <address
            className="lapstay-footer__contact"
            style={{ fontStyle: "normal" }}
          >
            <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
              <li>
                <svg
                  className="lapstay-footer__contact-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <rect x="2" y="4" width="20" height="16" rx="2" />
                  <path d="m2 7 10 6 10-6" />
                </svg>
                <a href="mailto:support@lapstay.in" itemProp="email">
                  support@lapstay.in
                </a>
              </li>
              <li className="lapstay-footer__phone-row">
                <svg
                  className="lapstay-footer__contact-icon"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  aria-hidden="true"
                >
                  <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1 1 .3 2 .7 3a2 2 0 0 1-.4 2.1L8 10.1a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c1 .4 2 .6 3 .7a2 2 0 0 1 1.6 2z" />
                </svg>

                <div className="lapstay-footer__phone-numbers">
                  <a
                    href="tel:+919289282561"
                    itemProp="telephone"
                    className="num-foot"
                  >
                    +91 9289282561
                  </a>
                  <a
                    href="tel:+919289286778"
                    itemProp="telephone"
                    className="num-foot"
                  >
                    +91 9289286778
                  </a>
                  <a
                    href="tel:+919811176683"
                    itemProp="telephone"
                    className="num-foot"
                  >
                    +91 9811176683
                  </a>
                </div>
              </li>
            </ul>
          </address>
        </div>
      </div>

      <div className="lapstay-footer__bottom">
        <img
          src={ornamentIcon}
          alt=""
          className="lapstay-footer__emblem-img"
          aria-hidden="true"
        />

        <p className="lapstay-footer__copyright">
          © {year} <span itemProp="name">Lapstay</span>. All rights reserved.
        </p>

        <ul className="lapstay-footer__legal-links">
          <li>
            <a href="/sitemap">Sitemap</a>
          </li>
          <li>
            <a href="/status">Status</a>
          </li>
        </ul>
      </div>
    </footer>
  );
}

export default Footer;
